import component from "containers/StaticPages/pages/FAQ";

export default {
  key: "powur-faq",
  title: "FAQ",
  path: "/:user?/faq",
  pageName: "FAQ",
  linkTarget: "/faq",
  component,
};
